<script setup lang="ts">
</script>

<template>
  <div
      class="
    absolute
    z-0
    w-full
    h-screen
    bg-gradient-to-b
    from-[#020617]
    via-[#1e40af]
    overflow-hidden
    flex
    items-center
    justify-center
  "
  >

    <!-- Основной радиальный свет -->


    <!-- Вращающаяся группа -->
    <div
        class="
      relative
      w-[650px]
      h-[650px]
    "
    >

      <!-- Фиолетовый круг -->
      <div
          class="
        absolute
        top-0
        -left-[200px]
        w-[1000px]
        h-[1000px]
        rounded-full
        bg-gradient-to-br
        from-purple-400
        via-violet-600
        to-transparent
        blur-[160px]
        opacity-90
      "
      ></div>


      <!-- Синий круг -->
      <div
          class="
        absolute
        right-0
        top-10
        w-[420px]
        h-[420px]
        rounded-full
        bg-gradient-to-br
        from-blue-400
        via-cyan-500
        to-transparent
        blur-[180px]
        opacity-85
      "
      ></div>


      <!-- Розовый круг -->
      <div
          class="
        absolute
        bottom-0
        left-20
        w-80
        h-80
        rounded-full
        bg-gradient-to-br
        from-pink-400
        via-fuchsia-600
        to-transparent
        blur-[170px]
        opacity-85
      "
      ></div>


      <!-- Голубой дополнительный круг -->
      <div
          class="
        absolute
        right-20
        bottom-20
        w-72
        h-72
        rounded-full
        bg-gradient-to-br
        from-cyan-300
        via-blue-500
        to-transparent
        blur-[150px]
        opacity-70
      "
      ></div>


      <!-- Центральное ядро -->
      <div
          class="
        absolute
        inset-0
        m-auto
        w-56
        h-56
        rounded-full
        bg-gradient-to-br
        from-white/90
        via-purple-300/50
        to-transparent
        blur-[120px]
      "
      ></div>


      <!-- Дополнительное свечение -->
      <div
          class="
        absolute
        inset-10
        rounded-full
        bg-purple-500/30
        blur-[200px]
      "
      ></div>

    </div>


    <!-- Зернистость поверх всего -->
    <div
        class="
      absolute
      inset-0
      pointer-events-none
      opacity-[0.12]
      mix-blend-overlay
    "
    >

      <svg
          class="
        w-full
        h-full
      "
      >

        <filter id="noise">
          <feTurbulence
              type="fractalNoise"
              baseFrequency="0.85"
              numOctaves="3"
              stitchTiles="stitch"
          />
        </filter>


        <rect
            width="100%"
            height="100%"
            filter="url(#noise)"
        />

      </svg>

    </div>

  </div>
</template>

<style scoped>
</style>
